module.exports = __webpack_public_path__ + "img/wechat.4beed15b.jpg";